import React, { useEffect, useState } from 'react'
import Drawer from 'components/Drawer'
import {
  HeaderDiv,
  StyledHeading,
  InfoFLex,
  InfoText,
  StyledCheckbox,
  StyledGroup,
  FooterFlex,
  ErrorMessage,
} from 'modules/Students/Partials/StudentsInfoTable/BlacklistDrawer/Styles/style'
import Button from 'components/Button'
import moment from 'moment'

const BlacklistDrawer = ({
  blacklistDrawer,
  setBlacklistDrawer,
  singleStudentData,
  blacklistStudent,
  blacklistStudentId,
  setCurrentPage,
  counter,
  setCounter,
}) => {
  const [studentInfo, setStudentInfo] = useState([])
  const [selected, setSelected] = useState([])
  const [showError, setShowError] = useState(false)

  useEffect(() => {
    const info = [
      {
        key: 1,
        heading: 'Name',
        value: `${singleStudentData?.firstName} ${
          singleStudentData?.middelName || ''
        } ${singleStudentData?.lastName}`,
      },
      {
        key: 2,
        heading: 'Roll Number',
        value: singleStudentData?.uniRollNo || '--',
      },
      {
        key: 3,
        heading: 'Batch ',
        value:
          moment(singleStudentData?.currentCourse?.startedOn / 1).format(
            'YYYY'
          ) +
            '-' +
            moment(singleStudentData?.currentCourse?.endedOn / 1).format(
              'YYYY'
            ) || '--',
      },
      {
        key: 4,
        heading: 'Deg & Department ',
        value: `${singleStudentData?.currentCourse?.degree} - ${singleStudentData?.currentCourse?.department}`,
      },
    ]
    setStudentInfo(info)
  }, [singleStudentData])
  useEffect(() => {
    blacklistDrawer && clearAll()
  }, [blacklistDrawer])

  const onSubmitForm = async() => {
    if (!selected.length) {
      setShowError(true)
      return
    }
    setShowError(false)
    const req = {
      blacklistedStatus: true,
      currentCourse: {
        collegeFeeBacklisted: selected?.includes('feeNotPaid'),
        conductBacklisted: selected?.includes('badConduct'),
        attendanceBacklisted: selected?.includes('lowAttendance'),
      },
    }
   await blacklistStudent(blacklistStudentId, req, clearAll, setBlacklistDrawer)
   setCurrentPage(0)
   setCounter(counter + 1)
  }

  const clearAll = () => {
    setSelected([])
    setShowError(false)
  }
  const onChange = event => {
    const value = event.target.value
    const isChecked = event.target.checked

    setSelected(prevSelected => {
      if (isChecked) {
        if (!prevSelected?.includes(value)) {
          return [...prevSelected, value]
        }
      } else {
        return prevSelected.filter(item => item !== value)
      }
      return prevSelected
    })
    setShowError(false)
  }

  const content = () => {
    const options = [
      {
        label: 'Fees not paid',
        value: 'feeNotPaid',
      },
      {
        label: 'Bad conduct',
        value: 'badConduct',
      },
      {
        label: 'Low attendance',
        value: 'lowAttendance',
      },
    ]
    return (
      <>
        <HeaderDiv>
          <StyledHeading>Student Info</StyledHeading>
          {studentInfo?.map(item => (
            <InfoFLex key={item?.key}>
              <InfoText>{item?.heading}</InfoText>
              <span>-</span>
              <InfoText>{item?.value}</InfoText>
            </InfoFLex>
          ))}
        </HeaderDiv>
        <StyledHeading>
          Reason to Blacklist <span>*</span>
        </StyledHeading>
        <StyledGroup key={selected.join('-')} defaultValue={selected}>
          {options?.map(item => (
            <StyledCheckbox
              key={item.value}
              value={item.value}
              label={item.label}
              onChange={onChange}
              checked={selected?.includes(item.value)}
            />
          ))}
        </StyledGroup>
        {showError && <ErrorMessage>Select any reason..!</ErrorMessage>}
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Close"
          onClick={() => {
            clearAll()
            setShowError(false)
            setBlacklistDrawer(false)
          }}
        />
        <Button.Primary onClick={onSubmitForm} text="Confirm" />
      </FooterFlex>
    )
  }

  return (
    <Drawer
      width="40%"
      title={'Blacklist Student'}
      placement="right"
      closable={true}
      onClose={() => setBlacklistDrawer(false)}
      visible={blacklistDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default BlacklistDrawer
